import { message } from "antd"
import { useCallback } from "react"

export const useCopyToClipboard = (text: string, transform?: (value: string) => string) => {
    const [messageApi, contextHolder] = message.useMessage()

    const copyToClipboard = useCallback(async (copy: string) => {
        const value = transform ? transform(copy) : copy
        await navigator.clipboard.writeText(value)
        await messageApi.open({
            type: 'success',
            content: text
        })
    }, [messageApi, text, transform])

    return { copyToClipboard, contextHolder }
}
